import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Schema } from '@sparefoot/react-commons';
import { withPageViewTracking } from 'components/core/library/tracking-utils';
import { Page } from 'components/core/Page';
import SLPHero from 'components/landing/SLPHero/SLPHero';

import './stateLandingPage.scss';
import { selectStateLandingSchema } from 'store/stateLanding/selectors';
import { PAGE_TYPES } from '@sparefoot/tracking-events';
import STATE_CONFIG from 'config/states';
import { STATE_HERO_IMAGES } from 'components/landing/SLPHero';
import CityCard from '../../components/core/CityCard/CityCard';

export const enhance = (Component) =>
	withPageViewTracking(PAGE_TYPES.STATE_LANDING)(Component);

export function getStateCode(fullStateOrCode) {
	if (fullStateOrCode && STATE_CONFIG[fullStateOrCode]) {
		return fullStateOrCode;
	}

	if (fullStateOrCode) {
		const entry = Object.entries(STATE_CONFIG).find(
			([, name]) => name === fullStateOrCode,
		);
		return entry ? entry[0] : null;
	}

	return null;
}

export function StateLandingPage() {
	const content = useSelector((state) => state.content.stateLanding);
	const pageType = useSelector((state) => state.pageMeta.pageType);
	const schemaData = useSelector((state) => selectStateLandingSchema(state));
	const cities = useSelector((state) => state.content.stateLanding.drilldownLinks);

	const fullState = content?.fullState;
	const stateCode = getStateCode(fullState) || content.state;
	const heroMapImage = stateCode ? STATE_HERO_IMAGES[stateCode] : null;

	return (
		<Page
			className="state-landing-page"
			pageType={pageType}
			landingPage
		>
			<Schema schema={schemaData} />
			<SLPHero
				searchLocation={{
					state: fullState,
					stateCode,
				}}
				heroMapImage={heroMapImage}
				headline={content?.heroHeadline}
				subtitle={content?.heroSubtitle}
			/>
			<div className="city-cards-grid">
				{cities?.map((city) => (
					<CityCard
						key={city.city}
						city={city.city}
						state={city.state}
						url={`/${city.city?.toLowerCase().split(' ').join('-')}-${city.state?.toLowerCase()}-self-storage.html`}
						content={city.content}
					/>
				))}
			</div>
		</Page>
	);
}

StateLandingPage.propTypes = {
	pageType: PropTypes.string,
	content: PropTypes.shape({
		fullState: PropTypes.string,
		bodyContent: PropTypes.string,
		allCities: PropTypes.array,
		drilldownLinks: PropTypes.array,
		state: PropTypes.string,
		heroHeadline: PropTypes.string,
		heroSubtitle: PropTypes.string,
	}),
	schemaData: PropTypes.object,
	cities: PropTypes.array
};

export default enhance(StateLandingPage);
